import {
  Button,
  Glyph,
  ButtonVariant,
  ButtonSize,
  ResponsiveValue,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { useResendPasswordResetEmail } from "../../ForgottenPassword/hooks/useResendPasswordResetEmail";

interface UserEmailProps {
  userEmail?: string;
  size?: ResponsiveValue<ButtonSize>;
}

export const ResendEmailButton = ({
  userEmail,
  size = [ButtonSize.Md],
}: UserEmailProps) => {
  const { submitRequest, disableSubmission } = useResendPasswordResetEmail();
  const disableButton = !userEmail || disableSubmission;

  const handlePasswordEmail = () => {
    if (userEmail) {
      submitRequest(userEmail);
    }
  };

  return (
    <Button
      data-testid="btn-resend-email"
      leftIcon={Glyph.Refresh}
      variant={ButtonVariant.PrimaryOnLight}
      size={size}
      onClick={handlePasswordEmail}
      disabled={disableButton}
    >
      <Trans id="forced-reset-password.cta.resend-email">Resend Email</Trans>
    </Button>
  );
};
